"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_API_URLS = void 0;
var NOTIFICATION_API_URLS;
(function (NOTIFICATION_API_URLS) {
    NOTIFICATION_API_URLS["MY_ACTIVE_AUCTIONS"] = "v2/auction/get-my-active-auctions";
})(NOTIFICATION_API_URLS = exports.NOTIFICATION_API_URLS || (exports.NOTIFICATION_API_URLS = {}));
